import { render } from "./ListePrixProduitCondTypeClient.vue?vue&type=template&id=0f71d4b7&ts=true"
import script from "./ListePrixProduitCondTypeClient.vue?vue&type=script&lang=ts"
export * from "./ListePrixProduitCondTypeClient.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__